var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTransfer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.373 4.51001C7.1997 2.88939 9.55803 1.99616 12 2.00001C17.523 2.00001 22 6.47701 22 12C22.0033 14.0439 21.3772 16.0393 20.207 17.715L17.5 12H20C20 10.4094 19.5259 8.85482 18.6381 7.53496C17.7504 6.2151 16.4893 5.18985 15.016 4.59017C13.5428 3.99049 11.9242 3.84362 10.367 4.16831C8.80985 4.493 7.38484 5.27451 6.274 6.41301L5.374 4.51101L5.373 4.51001ZM18.627 19.49C16.8003 21.1106 14.442 22.0039 12 22C6.477 22 2 17.523 2 12C2 9.87501 2.663 7.90501 3.793 6.28501L6.5 12H4C3.99997 13.5907 4.47412 15.1452 5.36188 16.4651C6.24964 17.7849 7.5107 18.8102 8.98397 19.4099C10.4572 20.0095 12.0758 20.1564 13.633 19.8317C15.1901 19.507 16.6152 18.7255 17.726 17.587L18.626 19.489L18.627 19.49ZM13.414 14.828L10.586 12L7.757 14.828L6.343 13.414L10.586 9.17201L13.414 12L16.243 9.17201L17.657 10.586L13.414 14.828Z",
    fill: "#080917"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransfer);
export default __webpack_public_path__ + "static/media/transfer.87cf297c02aa935b89c6e1b0d2dfde5d.svg";
export { ForwardRef as ReactComponent };